import { Operation } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { ERR_API_CALL_TRANSCRIPTS_NOT_READY } from '../../constants/errorCodes';
import { GET_CONVERSATION_DETAILS_RECORDING_AND_TRANSCRIPT } from '../../constants/operations';

export function operationHasQueriesOnly(operation: Operation) {
  return !operation.query.definitions.some((def) => {
    if (def.kind === 'OperationDefinition' && def.operation === 'mutation') {
      return true;
    }
  });
}

export default function (maxRetries: number): RetryLink {
  return new RetryLink({
    attempts: {
      max: maxRetries,
      retryIf: (error, operation) => {
        if (
          error?.extensions?.code === ERR_API_CALL_TRANSCRIPTS_NOT_READY &&
          operation.operationName ===
            GET_CONVERSATION_DETAILS_RECORDING_AND_TRANSCRIPT
        ) {
          // don't retry a 404, it's likely just not ready yet.
          // the component will handle and allow user to retry when needed.
          return false;
        }

        // this should not log errors because real errors will
        // get logged elsewhere (like an ErrorBoundary)
        console.warn('Retrying graphql error', error);
        return error && operationHasQueriesOnly(operation);
      },
    },
  });
}
